export const namefindSerpLink = (domain: string, utmCampaign: string) => {
  return (
    `https://www.godaddy.com/domainsearch/find?` +
    `key=parkweb&utm_source=godaddy&utm_medium=parkedpages&utm_campaign=${utmCampaign}&` +
    `tmskey=dpp_dbs&domainToCheck=${domain}&itc=namefind_redirect`
  );
};
